import { Chip, Stack, Typography } from '@mui/material';

interface ExternalAssigneeLabelProps {
  opsServiceName?: string | null;
}

/**
 * Ops Service name plus an "External" chip, shown wherever a ticket's technician would be when
 * the ticket is assigned to an outside vendor instead of a Nonce user.
 */
const ExternalAssigneeLabel = ({ opsServiceName }: ExternalAssigneeLabelProps) => (
  <Stack direction="row" alignItems="center" spacing={1} component="span">
    <Typography variant="body2" component="span">
      {opsServiceName || 'Unknown Ops Service'}
    </Typography>
    <Chip
      component="span"
      label="External"
      size="small"
      variant="outlined"
      color="secondary"
      sx={{ fontWeight: 500 }}
      data-test="service-ticket-external-chip"
    />
  </Stack>
);

export default ExternalAssigneeLabel;
